// extracted by mini-css-extract-plugin
export default {"wrapper":"FormSwitch_wrapper__4NaxA","switch":"FormSwitch_switch__4uKYl"};